import React, { useState, useEffect } from 'react';

const Version = () => {
  const [showVersion, setShowVersion] = useState(false);

  useEffect(() => {
      
    const handleKeyDown = (event) => {
      // Toggle version display on Ctrl+Shift+V
      if (event.ctrlKey && event.shiftKey && event.key === 'V') {
        setShowVersion(!showVersion);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };

  }, [showVersion]);

  const getEnvironmentFromURL = () => {
      // Get the base URL from environment variables
      const baseUrl = process.env.REACT_APP_PROD_BASE_URL;
    
      if (!baseUrl) {
        console.warn("Base URL is not defined in environment variables");
        return "unknown";
      }
    
      // Check if the URL contains environment indicators
      if (baseUrl.includes('-prod')) {
        return "Production";
      } else if (baseUrl.includes('-dev')) {
        return "Development";
      } else {
        return "unknown";
      }
    }

  return (
    showVersion && (
      <>
      <div className="version-info" style={{ position: 'fixed', bottom: '30px', right: '10px', backgroundColor: '#000', color : '#fff' , padding: '5px', border: '1px solid #000' }}>
        <span>App Version : {process.env.REACT_APP_VERSION}</span>
        <div>{getEnvironmentFromURL()}</div>
      </div>
      </>
    )
  );
};

export default Version;